import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'

function Deafness(props) {
  useEffect(() => {

  })
  return (
    <PageWrapper className={"dis-08-deafness-page"}>
      <div className="pageWrapper">
        <DetailHeader diseaseName={"Deafness"}></DetailHeader>
        <div className="MainContent">
          <div className="container">
            <div className="page-rte">
              <p>
                Hearing loss is defined as diminished acuity to sounds which
                would otherwise be heard normally. The terms hearing
                impaired or hard of hearing are usually reserved for people
                who have relative inability to hear sound in the speech
                frequencies. The severity of hearing loss is categorized
                according to the increase in intensity of sound above the usual
                level required for the listener to detect it.
              </p>
              <div className="row">
                <div className="col-12 textCenter">
                  <img src={require("../../img/Disease/Deafness/1.png")} alt="Deafness" />
                </div>
              </div>
              <br/>
              
              
              <p><b>Symptoms</b></p>
              <p>difficulty using the <a href='https://en.wikipedia.org/wiki/Telephone' className='links'>telephone</a></p>
              <p>loss of <a href='https://en.wikipedia.org/wiki/Sound_localization' className='links'>sound localization</a></p>
              <p>
                difficulty <a href='https://en.wikipedia.org/wiki/Speech_perception' className='links'>understanding speech</a>, especially of children and women
                whose voices are of a <a href='https://en.wikipedia.org/wiki/Voice_frequency#Fundamental_frequency' className='links'>higher frequency</a>.
              </p>
              <p>
                difficulty understanding speech in the presence of background noise  <a href='https://en.wikipedia.org/wiki/Cocktail_party_effect' className='links'>(cocktail party effect)</a>
              </p>
              <p>sounds or speech sounding dull, muffled or attenuated</p>
              <p>
                need for increased volume on television, radio, music and other
                audio sources
              </p>
              <p>Hearing loss is sensory, <b>but may have accompanying
                symptoms:</b></p>
              <p>pain or pressure in the ears</p>
              <p>a blocked feeling</p>
             
              <a
                className="links"
                href="https://en.wikipedia.org/wiki/Hearing_loss"
              >
                For More Details
              </a>
            </div>
          </div>
        </div>
      </div>


    </PageWrapper>
  );
}

export default Deafness;